// Currency formatting helper — supports Toothrocket's multi-region invoicing.
// QAR (Qatar) is the default; INR / USD / AED / EUR / GBP / SAR also covered.
//
// Usage:
//   import { fmt, symbol } from "@/lib/currency";
//   fmt(invoice.total, invoice.currency)  // → "QAR 1,250.00" or "₹ 1,250"
//   symbol("QAR")                          // → "QAR"

const SYMBOLS = {
    QAR: "QAR",
    INR: "₹",
    USD: "$",
    EUR: "€",
    GBP: "£",
    AED: "AED",
    SAR: "SAR",
};

// Currencies that historically display 0 decimal places in casual UI
const ZERO_DECIMAL_UI = new Set(["INR"]);

export function symbol(code) {
    if (!code) return "QAR";
    return SYMBOLS[code.toUpperCase()] || code.toUpperCase();
}

export function fmt(amount, code = "QAR", { showDecimals } = {}) {
    const cur = (code || "QAR").toUpperCase();
    const sym = symbol(cur);
    const n = Number(amount || 0);
    const maxDp = showDecimals ?? (ZERO_DECIMAL_UI.has(cur) ? 0 : 2);
    const minDp = showDecimals ? 2 : 0;
    const formatted = n.toLocaleString("en-US", { minimumFractionDigits: minDp, maximumFractionDigits: maxDp });
    // INR uses prefix-with-space; other codes use 3-letter ISO prefix
    return cur === "INR" ? `${sym} ${formatted}` : `${sym} ${formatted}`;
}
